// src/axiosInstance.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: `${BASE_URL}`, // Set your API base URL here
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to include the JWT token
axiosInstance.interceptors.request.use(
  (config) => {
    // Get JWT token from localStorage (or sessionStorage)
    const token = localStorage.getItem('jwtToken');
    
    if (token) {
      // Add the token to the Authorization header
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response, // Return the response if it's successful
  (error) => {

    
      // localStorage.removeItem("user");
      // localStorage.removeItem("jwtToken");
      // window.location.reload();
      //  navigate("/login");
      // window.location.href = '/login';
    return Promise.reject(error);
  }
);

export default axiosInstance;
